import React from 'react';
import ContactUs from '../components/ContactUs';
import Footer from '../components/Footer';

const PrivacyPolicy = () => {
  return (
    <>
      <div className="pages contact">
        
      </div>
      <div className="about-info">
      <div className="vc-office">
            <h1>Effective Date: 31st March 2025 </h1>
      <p> <br></br>
      At Little Sanctum Montessori, we respect your privacy.

We collect personal information (like your name, email, or phone number) only when you submit it through our contact form. This information is used solely to respond to your inquiries.

We do not share, sell, or misuse your personal data.

We may use cookies and third-party tools to enhance your browsing experience and better understand how visitors use our website. You can manage cookie settings in your browser.

If you have any questions, please contact us at admin@littlesanctumpreschools.in</p></div></div>
      
    </>
  )
}

export default PrivacyPolicy
